import React, { useEffect, useRef } from "react";

const useFadeIn = (duration = 1, delay = 0) => {
	const element = useRef();
	useEffect(() => {
		if (element.current) {
			const { current } = element;
			current.style.transition = `opacity ${duration}s ease-in-out ${delay}s`;
			current.style.opacity = 1;
		}
	}, []);
	return { ref: element, style: { opacity: 0 } };
};

function Fade() {
	const Fadeinh1 = useFadeIn(2);
	const Fadeinp = useFadeIn(2, 0.7);
	return (
		<div>
			<h1 {...Fadeinh1}>Hello</h1>
			<p {...Fadeinp}>
				Lorem Ipsum is simply dummy text of the printing and typesetting
				industry. Lorem Ipsum has been the industry's standard dummy text
				ever since the 1500s, when an unknown printer took a galley of
				type and scrambled it to make a type specimen book. It has
				survived not only five centuries, but also the leap into
				electronic typesetting, remaining essentially unchanged. It was
				popularised in the 1960s with the release of Letraset sheets
				containing Lorem Ipsum passages, and more recently with desktop
				publishing software like Aldus PageMaker including versions of
				Lorem Ipsum.
			</p>
		</div>
	);
}

export default Fade;
